<template>
  <div class="fixed top-0 left-0 w-full h-full z-50 bg-black/40"></div>
</template>
